// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/component/element/InputNumber.css
// module id = 1997
// module chunks = 0